export const DAY_LABELS = {
  es: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'],
  en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
} as const;

export const normalizeDate = (date: Date): Date => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return now;
  }
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};

export const getWeekStart = (date: Date, locale: 'en' | 'es'): Date => {
  const normalized = normalizeDate(date);
  const dayOfWeek = normalized.getDay();
  const weekStartOffset =
    locale === 'en' ? -dayOfWeek : dayOfWeek === 0 ? -6 : 1 - dayOfWeek;
  const weekStart = new Date(normalized);
  weekStart.setDate(normalized.getDate() + weekStartOffset);
  return weekStart;
};

export const normalizeDateArray = (dates: Date[]): Date[] =>
  dates.map(normalizeDate);

export const isDateInArray = (date: Date, dateArray: Date[]): boolean => {
  const normalized = normalizeDate(date);
  return dateArray.some(
    (arrayDate) => normalizeDate(arrayDate).getTime() === normalized.getTime(),
  );
};
